<form style="margin: 13px;" (ngSubmit)="attorneyConnectFormSub()" #f="ngForm">
  <div class="row" class="font-weight-bold title-style">
    Add New Client Connection
  </div>
  <div class="addnew" fxLayout="row" fxLayoutAlign="center center" style="margin-bottom:  15px;">
    <a class="link" routerLink="../clients">
      << Back to Client list</a>
  </div>
  <div class="content-container">
    <div class="row" class="font-weight-bold">
      <h5 class="labelText">Company / Client Name</h5>
    </div>
    <div class="form-row ">
      <div class="form-group col-md-6">
        <label>Company/Client</label>
        <div class="row">
          <select class="form-control" name="listAttorneys" aria-placeholder="Select lawfirm" [(ngModel)]="attorneyId"
            #listAttorneys="ngModel" required>
            <option *ngFor="let item of attorneys" [value]="item.attorneyId">{{item.attorneyName}}
            </option>
          </select>
          <span class="invalid-message"
            *ngIf="(listAttorneys.touched || f.submitted) && listAttorneys.errors?.required">
            **Field is required
          </span>
        </div>
      </div>
    </div>

    <div>
      <div class="row" class="font-weight-bold ">
        <h5 class="labelText">Contact Person Details</h5>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label>First Name</label>
          <input type="text" class="form-control"
            [ngClass]="{'im-input-error':(firstName.touched || f.submitted) && firstName.errors?.required}"
            name="firstName" [(ngModel)]="attorney.firstName" placeholder="Enter" #firstName="ngModel" required />
          <span class="invalid-message" *ngIf="(firstName.touched || f.submitted) && firstName.errors?.required">
            **Field is required
          </span>
        </div>
        <div class="form-group col-md-4">
          <label>Last Name</label>
          <input type="text" class="form-control" name="lastName" [(ngModel)]="attorney.lastName"
            [ngClass]="{'im-input-error':(lastName.touched || f.submitted) && lastName.errors?.required}"
            placeholder="Enter" #lastName="ngModel" required>
          <span class="invalid-message" *ngIf="(lastName.touched || f.submitted) && lastName.errors?.required">
            **Field is required
          </span>
        </div>
        <div class="form-group col-md-4">
          <label>Middle Name (Optional)</label>
          <input type="text" class="form-control" name="middleName" [(ngModel)]="attorney.middleName"
            placeholder="Enter ">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6 ">
          <label>Email</label>
          <input type="text" [ngClass]="{'im-input-error':(email.touched || f.submitted) && email.errors?.required}"
            name="email" class="form-control" [(ngModel)]="attorney.emailId" #email="ngModel" required />
          <span class="invalid-message" *ngIf="(email.touched || f.submitted) && email.errors?.required">
            **Field is required
          </span>
        </div>
      </div>
    </div>
    <div class="form-row pl-1">
      <label>Add Note (Optional)</label>
      <textarea class="form-control" rows="4" name="notes" [(ngModel)]="attorney.note" type="text" placeholder="Enter">
               </textarea>
    </div>

    <div class="row mt-2">
      <button type="submit" class="ml-auto mb-2 im-btn im-btn-primary im-btn-md" [disabled]="f.invalid">
        Connect
      </button>
    </div>
  </div>
</form>
